import { Box, Dialog, IconButton, Tooltip } from '@mui/material';
import React, { useEffect, useMemo } from 'react';

import DesktopDeselectedImage from '../../images/desktop_deselected.svg';
import Grid from '@mui/material/Unstable_Grid2';
import MobileSelectedImage from '../../images/mobile_selected.svg';
import { ReactSVG } from 'react-svg';
import { styled } from '@mui/system';
import styles from './LessonPlayerMobilePreview.module.css';

/** Display size of QR code. */
const QR_SIZE = 128;

/** QR generation link. */
const QR_GENERATOR = `http://api.qrserver.com/v1/create-qr-code/?data={data}&size=${QR_SIZE}x${QR_SIZE}&qzone=2&format=svg&bgcolor=f4f4f4`;

export interface LessonPlayerMobilePreviewProps {
  /** URL of the preview link to load in the iframe. */
  link: string;
  /** Callback to close the dialog window. */
  onClose?: () => void;
}

const DesktopDeselectedIcon = () => <ReactSVG src={DesktopDeselectedImage} />;
const MobileSelectedIcon = () => <ReactSVG src={MobileSelectedImage} />;

const StyledGrid = styled(Grid)(() => ({
  '& [disabled]': { opacity: 0.5 },
  '& svg': { width: 32, height: 32 }
}));

const LessonPlayerMobilePreview = (props: LessonPlayerMobilePreviewProps) => {
  const { link } = props;
  const qrUrl = useMemo(
    () => QR_GENERATOR.replace('{data}', encodeURIComponent(link)),
    [link]
  );

  useEffect(() => {
    const onMessage = (event: MessageEvent) => {
      if (
        event.origin === document.location.origin &&
        event.data?.action === 'onClose'
      ) {
        props.onClose?.();
      }
    };
    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  });

  return (
    <Dialog open fullScreen>
      <Grid
        container
        direction="column"
        alignItems="center"
        className={styles.background}
      >
        <StyledGrid>
          <Tooltip title="Return to desktop view">
            <IconButton onClick={props.onClose}>
              <DesktopDeselectedIcon />
            </IconButton>
          </Tooltip>
          <IconButton disabled>
            <MobileSelectedIcon />
          </IconButton>
        </StyledGrid>
        <Grid>
          <Box className={styles.mobileFrame}>
            <iframe
              width={400}
              height={window.innerHeight - 120}
              src={link}
              style={{ border: 'none' }}
            ></iframe>
          </Box>
          <Box className={styles.qrAnchor}>
            <Grid container direction="column" alignItems="center">
              <label>DEVICE PREVIEW</label>
              <Grid className={styles.qrFrame}>
                <div className={styles.qrFrames}></div>
                <a href={link} target="_blank">
                  <img
                    src={qrUrl}
                    width={QR_SIZE}
                    height={QR_SIZE}
                    alt={link}
                    title={link}
                  />
                </a>
                <div className={styles.qrFrames}></div>
              </Grid>
              <label title="Generated via goQR.me">Scan with your camera</label>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default LessonPlayerMobilePreview;
